import type { CityConfig } from "../city-template/types";

export const traverseCityConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Michigan DHHS Vital Records", href: "https://www.michigan.gov/mdhhs/adult-child-serv/informedconsent/vitalrecords", description: "Official Michigan vital records office in Lansing" },
    { label: "Marriage Licenses — Grand Traverse County Clerk", href: "https://www.grandtraverse.org/clerk", description: "Grand Traverse County Clerk — marriage license issuance" },
    { label: "Divorce Records — Grand Traverse County Clerk", href: "https://www.grandtraverse.org/clerk", description: "Grand Traverse County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Michigan DHHS for online vital record orders" },
  ],
  city: "Traverse City",
  state: "Michigan",
  stateAbbr: "MI",
  slug: "traverse-city",
  route: "/traverse-city",
  title: "Emergency Passport Traverse City, MI — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Traverse City, Michigan — as fast as 24 hours. Fast passport renewal and new passport applications for Traverse City, Petoskey, Charlevoix, Cadillac, and all Northern Michigan residents. Cherry Capital Airport and Leelanau Peninsula coverage. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Traverse City, MI",
  heroSubtitle: "Traverse City travelers — Northern Michigan tourists, Leelanau Peninsula wine country visitors, Cherry Capital Airport flyers, and international families — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of Grand Traverse County and Northern Michigan.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20Traverse%20City%20Michigan%20shoreline%20on%20Grand%20Traverse%20Bay%2C%20cherry%20orchards%20in%20the%20foreground%2C%20downtown%20buildings%2C%20vibrant%20blue%20water%2C%20lush%20green%20forests%2C%20rolling%20hills%2C%20warm%20summer%20golden%20hour%20light%2C%20no%20text%20no%20people%2C%20cinematic%20Northern%20Michigan%20landscape%20photography&width=1800&height=700&seq=traverse-city-hero-001&orientation=landscape",
  heroImageAlt: "Traverse City Michigan shoreline on Grand Traverse Bay with cherry orchards and downtown at golden hour",
  geoPosition: "44.7631;-85.6206",
  geoPlacename: "Traverse City, Michigan",
  lastModified: "2026-06-02",
  regionalAgency: {
    name: "Detroit Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 240 miles south of Traverse City — appointments required, typically booked 2 weeks out",
  },
  nearbyCitiesZips: [
    { name: "Traverse City", zips: "49684, 49685, 49686, 49696" },
    { name: "Acme", zips: "49610" },
    { name: "Garfield", zips: "49684" },
    { name: "Blair", zips: "49684" },
    { name: "Elk Rapids", zips: "49629" },
    { name: "Kalkaska", zips: "49646" },
    { name: "Cadillac", zips: "49601" },
    { name: "Charlevoix", zips: "49720" },
    { name: "Petoskey", zips: "49770" },
    { name: "Harbor Springs", zips: "49740" },
    { name: "Interlochen", zips: "49643" },
    { name: "Frankfort", zips: "49635" },
    { name: "Beulah", zips: "49617" },
    { name: "Benzonia", zips: "49616" },
    { name: "Gaylord", zips: "49734, 49735" },
    { name: "Mancelona", zips: "49659" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to the Detroit Passport Agency — no appointment wait" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-global-line", title: "Northern Michigan Expertise", desc: "Cherry Capital Airport, Leelanau Peninsula, and Mackinac travel support" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from anywhere in Grand Traverse County" },
  ],
  internalLinks: [
    { name: "Expedited passport in Petoskey, MI", route: "/petoskey" },
    { name: "Emergency passport services in Grand Rapids, MI", route: "/grand-rapids" },
    { name: "Urgent passport services in Lansing, MI", route: "/lansing-mi" },
    { name: "Michigan passport services overview", route: "/michigan" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Traverse City, Michigan via secure registered courier and has direct access to the Detroit Passport Agency at 211 W. Fort St, Suite 1300. Our registered couriers hand-deliver your documents — meaning you get faster results without the 240-mile drive or appointment wait. Traverse City residents can ship from any UPS or FedEx in Grand Traverse County.",
  fpcOfficeDistance: "Serving Traverse City, Acme, Garfield, Blair, Elk Rapids, Kalkaska, Cadillac, Charlevoix, Petoskey, Harbor Springs, Interlochen, Frankfort, Beulah, Benzonia, and all of Northern Michigan",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Traverse City and the greater Northern Michigan region. From the Grand Traverse Bay shoreline to the Leelanau Peninsula wine country, from the Cherry Capital Airport to the Mackinac Bridge corridor — we serve all of Northern Michigan. The Detroit Passport Agency is approximately 240 miles south, and our couriers have direct access to it.",
  nearbyCitiesIntro: "We serve Traverse City and all Northern Michigan communities including Acme, Garfield, Blair, Elk Rapids, Kalkaska, Cadillac, Charlevoix, Petoskey, Harbor Springs, Interlochen, Frankfort, Beulah, Benzonia, Gaylord, and Mancelona. We also serve Cherry Capital Airport travelers and Leelanau Peninsula visitors.",
  howItWorksIntro: "Most Traverse City travelers complete everything online and ship documents overnight. No driving 240 miles to the Detroit Passport Agency or waiting weeks for an appointment — our registered couriers handle the submission for you.",
  mistakesIntro: "Traverse City is a unique Northern Michigan tourist hub with heavy Cherry Capital Airport travel, Leelanau Peninsula wine tourism, and international family visits. Here are the most common passport mistakes we see from Grand Traverse County travelers.",
  testimonialsIntro: "Traverse City travelers — from Cherry Capital Airport flyers to Leelanau Peninsula tourists to international families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Traverse City, MI? Here are the most common ones we hear from Grand Traverse County and Northern Michigan travelers.",
  statePageRoute: "/states/michigan",
  statePageName: "Michigan",
  dmvWebsite: "https://www.michigan.gov/sos",
  dmvLabel: "Michigan SOS — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "No appointment wait — we handle submission", "Perfect for Cherry Capital Airport and Leelanau travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Detroit Passport Agency (Self-Service)",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — typically 2 weeks out", "Life-or-death emergencies only", "Must appear in person in Detroit — 240-mile drive", "Full day commitment — parking + wait time"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Traverse City travelers with immediate departure needs — as fast as 24 hours. Our couriers go directly to the Detroit Passport Agency. Perfect for last-minute Cherry Capital Airport flights, family emergencies, and Leelanau Peninsula travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier to Detroit Passport Agency", "Cherry Capital Airport and Northern Michigan travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Traverse City adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Grand Traverse County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Traverse City residents and families — including international students, new citizens, and Northern Michigan families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Traverse City residents who lost their passport before international travel or Cherry Capital Airport departure.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Traverse City-area families planning international vacations, Mackinac trips, or visiting family abroad.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Traverse City and Northern Michigan residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Traverse City MI", description: "Urgent passport processing for Traverse City Michigan travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Traverse City MI", description: "Fast passport renewal for Traverse City Michigan residents with a previously-issued passport." },
    { name: "First-Time Passport Traverse City MI", description: "New passport application services for Traverse City Michigan residents applying for their first passport." },
    { name: "Child Passport Traverse City MI", description: "Minor passport services for Traverse City Michigan families with children under 16." },
  ],
  testimonials: [
    {
      name: "Jennifer L.",
      location: "Traverse City, MI",
      rating: 5,
      text: "Flying out of Cherry Capital to Toronto in 6 days and my passport was expired. Fast Passport Center saved the trip — renewed in 3 days. I shipped from the UPS Store on South Airport and had it back before I even packed.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Mark R.",
      location: "Elk Rapids, MI",
      rating: 5,
      text: "Business trip to London in 4 days and my passport was lost. Fast Passport Center had a replacement in my hands in 48 hours. No driving 240 miles to Detroit, no appointment wait. Their courier service is a lifesaver for Northern Michigan.",
      service: "Lost Passport Replacement",
    },
    {
      name: "Sarah K.",
      location: "Petoskey, MI",
      rating: 5,
      text: "Family trip to France with 10 days notice. Four passports for our family. Fast Passport Center processed all of them in 5 days. They caught a mistake on one of my kid's forms that would have delayed us.",
      service: "Family Passport Bundle",
    },
    {
      name: "Thomas W.",
      location: "Charlevoix, MI",
      rating: 5,
      text: "Wine tour group going to Italy and I realized my passport was expiring too soon. Fast Passport Center got me a renewed passport in 2 days. I shipped from the FedEx in Traverse City and everything was seamless.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "tc-1",
      name: "Detroit Passport Agency",
      type: "Regional Passport Agency",
      address: "230 S Dearborn St, Suite 380",
      city: "Detroit",
      state: "MI",
      zip: "48226",
      phone: "(313) 226-7110",
      hours: "Mon–Fri: 8:00 AM – 3:00 PM (by appointment only)",
      distance: "Approximately 240 miles south of Traverse City — appointments typically booked 2 weeks out",
      website: "https://travel.state.gov/content/travel/en/passports/get-fast/passport-agencies.html",
      websiteLabel: "Schedule Appointment",
      notes: "Michigan's only regional passport agency. Serves travelers with international travel within 14 days (or 28 days with visa). Appointments are required — no walk-ins. Fast Passport Center couriers have direct access and can skip the appointment backlog.",
      icon: "ri-government-line",
    },
    {
      id: "tc-2",
      name: "Traverse City Post Office",
      type: "USPS Passport Acceptance Facility",
      address: " 1203 S. Garfield Ave",
      city: "Traverse City",
      state: "MI",
      zip: "49684",
      phone: "(231) 946-4874",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Traverse City — near downtown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Traverse City acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to downtown Traverse City and Grand Traverse Bay residents.",
      icon: "ri-mail-line",
    },
    {
      id: "tc-3",
      name: "Interlochen Post Office",
      type: "USPS Passport Acceptance Facility",
      address: " 9700 U.S. 31",
      city: "Interlochen",
      state: "MI",
      zip: "49643",
      phone: "(231) 276-7222",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Interlochen — approximately 15 miles southwest of Traverse City",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Interlochen, Benzie County, and southwestern Grand Traverse County residents. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "tc-4",
      name: "Petoskey Post Office",
      type: "USPS Passport Acceptance Facility",
      address: " 1322 Bay View Rd",
      city: "Petoskey",
      state: "MI",
      zip: "49770",
      phone: "(231) 347-2534",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Petoskey — approximately 70 miles north of Traverse City",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Petoskey, Harbor Springs, and northern Lower Peninsula residents. Larger facility with more appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "tc-5",
      name: "Cadillac Post Office",
      type: "USPS Passport Acceptance Facility",
      address: " 201 N. Mitchell St",
      city: "Cadillac",
      state: "MI",
      zip: "49601",
      phone: "(231) 775-9911",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Cadillac — approximately 50 miles south of Traverse City",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Cadillac, Manton, and southern Grand Traverse County residents. Book early during summer travel season.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — typically 2 weeks out", fpc: "No — we handle the Detroit agency submission" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "In-Person Requirement", agency: "Yes — must appear at 211 W. Fort St", fpc: "No — ship from anywhere in Grand Traverse County" },
    { feature: "Cherry Capital & Northern MI Expertise", agency: "No tailored advice", fpc: "Yes — Cherry Capital Airport and Northern Michigan travel" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Traverse City and Northern Michigan travelers often discover passport issues right before Cherry Capital Airport departure. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-passport-line",
      title: "Using a Passport Card for International Air Travel",
      description: "Some Northern Michigan travelers assume a passport card is sufficient for all travel — but passport cards are only valid for land and sea border crossings. All international flights require a passport book.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo shops sometimes produce photos that meet ID requirements but not passport standards. Photos must be exactly 2x2 inches with a plain white or off-white background, taken within 6 months.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form for New Passports",
      description: "Missing signatures or incorrect form completion are the #1 rejection reasons at Northern Michigan acceptance facilities. Our document review catches these before submission.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking Cherry Capital Airport Flight Requirements",
      description: "Cherry Capital Airport (TVC) has limited international flight options. Many Traverse City travelers connect through DTW or Chicago O'Hare. Verify passport requirements for all connecting airports.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming the Detroit Agency Has Walk-In Slots",
      description: "The Detroit Passport Agency requires appointments and is typically booked 2 weeks out. There are no same-day walk-in slots — plan ahead or use Fast Passport Center's courier service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Grand Traverse County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Traverse City, Cadillac, or Petoskey." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier hand-delivers to the Detroit Passport Agency — no 240-mile drive or appointment wait required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Grand Traverse County address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Where is the nearest passport agency to Traverse City, MI?", a: "The Detroit Passport Agency is the nearest regional passport agency to Traverse City, located at 230 S Dearborn St, Suite 380, Chicago, IL 60604 — approximately 240 miles south. It is open Monday through Friday 8:00 AM – 3:00 PM by appointment only. Appointments are typically booked 2 weeks out. Fast Passport Center's registered couriers have direct access and can submit applications without individual appointments, saving you the long drive and wait." },
    { q: "How fast can I get an emergency passport in Traverse City?", a: "Fast Passport Center offers emergency passport processing in Traverse City, Michigan in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Detroit Passport Agency — without you needing to drive 240 miles south or take a day off work." },
    { q: "Do I need a passport for international flights from Cherry Capital Airport?", a: "Yes. All international flights require a passport book. Cherry Capital Airport (TVC) primarily serves domestic destinations, but many Traverse City travelers connect through Detroit Metro (DTW) or Chicago O'Hare (ORD) for international flights. A passport book is required for all international air travel regardless of your departure airport." },
    { q: "Can I get an expedited passport in the Traverse City suburbs like Acme or Garfield?", a: "Absolutely. Fast Passport Center serves all of Grand Traverse County including Acme, Garfield, Blair, Interlochen, and all surrounding communities. Our courier service works the same way everywhere — complete online, ship documents, we handle the rest." },
    { q: "What airports do Traverse City-area travelers use for international flights?", a: "Cherry Capital Airport (TVC) in Traverse City is the local airport — primarily domestic flights with connections to major hubs. Detroit Metro Wayne County Airport (DTW) in Romulus is the primary international departure hub — approximately 240 miles south. Many Traverse City travelers also use Chicago O'Hare (ORD) for international connections. Always verify your passport is valid for at least 6 months past your return date." },
    { q: "How much does an expedited passport cost in Traverse City, MI?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Can Traverse City-area residents get passport photos taken locally?", a: "Yes. Walgreens and CVS locations throughout Traverse City, Cadillac, and Petoskey offer passport photos. UPS Stores, FedEx Office locations, and many AAA offices also provide passport photos. Photos must be 2x2 inches on a white or off-white background, taken within the last 6 months." },
    { q: "Does Fast Passport Center serve the Upper Peninsula from Traverse City?", a: "Yes. Fast Passport Center serves all of Michigan including the Upper Peninsula. Our courier service is especially valuable for remote UP communities, which would otherwise face a 10+ hour drive to the Detroit Passport Agency. We serve Marquette, Sault Ste. Marie, Houghton, Escanaba, and all UP communities — you just ship your documents overnight and we handle everything from there." },
  ],
  photoLocations: [
    { name: "Walgreens — South Airport", address: "1500 S. Airport Rd W, Traverse City, MI 49686", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS Pharmacy — Traverse City", address: " 317 S. Union St, Traverse City, MI 49684", hours: "Mon–Sun: 8AM–9PM" },
    { name: "UPS Store — Traverse City", address: " 316 S. Union St, Traverse City, MI 49684", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Traverse City", address: " 1495 S. Airport Rd W, Traverse City, MI 49686", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "Michigan SOS — Traverse City", address: " 1544 U.S. 31 S, Traverse City, MI 49684", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Michigan Secretary of State office for driver's licenses, REAL ID, and vehicle registration. Serves Traverse City, Acme, and Grand Traverse County. Reserve a spot online to avoid wait times.", featured: true },
    { name: "Michigan SOS — Cadillac", address: " 818 S. Mitchell St, Cadillac, MI 49601", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Serves Cadillac, Manton, and southern Grand Traverse County communities. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "TVC",
      name: "Cherry Capital Airport",
      distance: "Located in Traverse City — local airport",
      address: "727 Fly Don't Dr, Traverse City, MI 49686",
      note: "Regional airport serving Northern Michigan. Primarily domestic flights with connections to major hubs. Delta, American, and United service. Not a major international gateway — most Traverse City travelers connect through DTW or Chicago O'Hare for international flights.",
      flightUrl: "https://www.tvcairport.com/",
      flightLabel: "TVC Airport Info",
      featured: false,
    },
    {
      code: "DTW",
      name: "Detroit Metro Wayne County Airport",
      distance: "Approximately 240 miles south of Traverse City via I-75",
      address: "1 Detroit Metro Airport, Romulus, MI 48242",
      note: "Primary international hub for Northern Michigan. Delta Air Lines hub. Direct flights to London, Amsterdam, Tokyo, Paris, Mexico City, Cancun, and 40+ international destinations. Largest airport in Michigan. Most Traverse City international travelers connect through DTW.",
      flightUrl: "https://www.metroairport.com/",
      flightLabel: "DTW Flight Info",
      featured: true,
    },
  ],
};